import { render, staticRenderFns } from "./ResolveBets.vue?vue&type=template&id=51370254&"
import script from "./ResolveBets.vue?vue&type=script&lang=js&"
export * from "./ResolveBets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports